import { FC, useState, useMemo, useEffect, memo } from 'react';
// 组件
import {
  EditOutlined,
  LoadingOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import SelectTable from '../SelectTable';
// 常量
import { EditSelectLabel, EditSelectProps, EditSelectValue } from './interface';
import { SUCCESS_STATUS_CODE } from '../constants/constant';
import styles from './style.module.less';

/** 可编辑下拉列表 */
const EditSelect: FC<EditSelectProps> = memo(props => {
  const {
    value,
    label,
    name,
    defaultParams,
    style,
    className,
    splitStr,
    disabled,
    fetchApi,
    onSuccess,
    onFail,
    onBefore,
    selectTableProps,
  } = props;
  const [currentValue, setCurrentValue] = useState<EditSelectValue>();
  const [currentLabel, setCurrentLabel] = useState<EditSelectLabel>();
  const [edit, setEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setCurrentValue(value);
  }, [value]);
  useEffect(() => {
    setCurrentLabel(label);
  }, [label]);
  const handleClick = () => {
    setEdit(true);
  };
  const handleClose = () => {
    setEdit(false);
  };
  const handleChange = async (value: any, item: any) => {
    if (value) {
      let params = { ...defaultParams, [name]: value };
      if (onBefore) params = onBefore(params);
      if (!params) return;
      setEdit(false);
      setLoading(true);
      const res = await fetchApi(params);
      setLoading(false);
      if (res.code === SUCCESS_STATUS_CODE) {
        onSuccess?.(res.data);
        if (Array.isArray(item)) {
          const text = item
            .map(v => v[selectTableProps.nameKey])
            .join(splitStr);
          setCurrentValue(value);
          setCurrentLabel(text);
        }
      } else {
        onFail?.(res);
      }
    }
  };
  const initOptions = useMemo(() => {
    const { valueKey, nameKey } = selectTableProps;
    const newInitOption: any[] = [];
    if (value && label) {
      if (typeof value === 'string' && typeof label === 'string') {
        newInitOption.push({
          [nameKey]: label,
          [valueKey]: value,
        });
      }
      if (Array.isArray(value) && Array.isArray(label)) {
        value.forEach((item, index) => {
          newInitOption.push({
            [nameKey]: label[index],
            [valueKey]: item,
          });
        });
      }
    }
    return newInitOption;
  }, [value, label, selectTableProps]);
  const renderLabel = useMemo(() => {
    if (!currentLabel) return '';
    if (Array.isArray(currentLabel)) {
      if (!currentLabel.length) return '';
      return currentLabel.join(splitStr);
    }
    return currentLabel;
  }, [currentLabel]);
  return (
    <>
      {
        disabled ? label : (
          <div style={style} className={className}>
            {edit ? (
              <div className={styles.editWrapper}>
                <SelectTable
                  style={{ width: '100%' }}
                  value={currentValue}
                  initOptions={initOptions}
                  initLoad={currentValue ? false : true}
                  {...selectTableProps}
                  onChange={handleChange}
                />
                <CloseCircleOutlined className={styles.close} onClick={handleClose} />
              </div>
            ) : (
              <div>
                <span className={styles.paddingRight}>{renderLabel}</span>
                {loading ? (
                  <LoadingOutlined className={styles.link} />
                ) : (
                  <EditOutlined className={styles.hover} onClick={handleClick} />
                )}
              </div>
            )}
          </div>
        )
      }
    </>
  );
});

EditSelect.defaultProps = {
  splitStr: ', ',
};

export default EditSelect;
